// Zeit-Hilfen für Verlauf und Log der Lead-Seite (Runde 7B): aus Feed.tsx herausgelöst, damit Verlauf und Log dieselben Tageszeilen
// und Kurzzeiten benutzen, ohne dass sich die beiden Dateien gegenseitig einbinden.
import { berlinTeile, gueltig, heute, tageZwischen } from "../../werkzeuge/zeit";

/** Kurze, gut scanbare Zeitangabe (Berlin): „Heute 09:39“, „Gestern 18:03“, „09.10. 09:39“, „24.09.2025“ */
export function kurzeZeit(iso: string | null | undefined): string {
  if (!gueltig(iso)) return "";
  const { datum, zeit } = berlinTeile(iso);
  const h = heute();
  if (datum === h) return `Heute ${zeit}`;
  if (tageZwischen(datum, h) === 1) return `Gestern ${zeit}`;
  const [j, m, t] = datum.split("-");
  return `${t}.${m}.${j}`;
}

/** Berliner Kalendertag eines Zeitpunkts (JJJJ-MM-TT) für die Tageszeilen. */
export function tagKey(iso: string | null | undefined): string | null {
  return gueltig(iso) ? berlinTeile(iso).datum : null;
}

export function tagLabel(datum: string): string {
  const h = heute();
  if (datum === h) return "Heute";
  if (tageZwischen(datum, h) === 1) return "Gestern";
  const [j, m, t] = datum.split("-");
  return `${t}.${m}.${j}`;
}
